import React, { createContext, useMemo, useState } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }: any) => {
  const [auth, setAuth] = useState({});

  const authWrapper = useMemo(() => ({ auth, setAuth }), [auth, setAuth]);

  return (
    <AuthContext.Provider value={authWrapper}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
